var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CheckinCampaignList",
      "extra-items": [{
        text: _vm.checkinCampaignName.length > 13 ? _vm.checkinCampaignName.slice(0, 13) + '...' : _vm.checkinCampaignName,
        to: {
          name: 'CheckinCampaignView',
          params: {
            id: _vm.checkinCampaignId
          }
        }
      }, '簽到任務管理']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.step == '',
      disabled: !_vm.checkinCampaignId
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("簽到任務管理")])])])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '簽到活動名稱',
      "name": _vm.checkinCampaignName
    }
  }), _c('div', {
    staticClass: "row d-flex mb-12 mb-xl-12"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12 mb-12 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 簽到任務管理 ")]), _vm.isMissionSetting ? _c('div', {
    staticClass: "ml-2",
    domProps: {
      "textContent": _vm._s(_vm.missionSettingText)
    }
  }) : _vm._e()])]), !_vm.isMissionSetting ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-primary",
      "disabled": _vm.showLoading
    },
    on: {
      "click": function click($event) {
        return _vm.selectMissionSetting(_vm.standardMission);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增簽到任務")])], 1) : _vm._e(), _c('CheckinMissionSetting', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMissionSetting,
      expression: "isMissionSetting"
    }],
    ref: "missionSetting",
    attrs: {
      "selectedMission": _vm.selectedMission,
      "checkinCampaignId": _vm.checkinCampaignId
    },
    on: {
      "close": _vm.closeMissionSetting
    }
  }), _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.missions.length > 0 && !_vm.isMissionSetting,
      expression: "missions.length > 0 && !isMissionSetting"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.missions,
      "fields": _vm.missionFields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'name')))])];
      }
    }, {
      key: "cell(period_type)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'period_type')))])];
      }
    }, {
      key: "cell(memo)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'memo')))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info"
          },
          on: {
            "click": function click($event) {
              return _vm.selectMissionSetting(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 編輯 ")]), _vm.checkPermission([_vm.consts.CHECKIN_MISSION_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteMission(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 移除 ")]) : _vm._e()];
      }
    }], null, false, 697321418)
  })], 1) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }